import type { FluxErrorEntityErrorCodes } from '../types.js';

export const StageErrorCodes = {
  StageArchived: {
    code: 'stage/archived',
    explanation:
      'A etapa que você está tentando modificar está arquivada. Etapas arquivadas são imutáveis.',
    localizations: {},
    message: 'Esta etapa está arquivada e não pode ser modificada.',
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  StageDeleteFailed: {
    code: 'stage/delete-failed',
    explanation: 'Ocorreu um erro ao tentar excluir a etapa.',
    localizations: {},
    message: 'Erro ao excluir a etapa. Tente novamente.',
  },
  StageDoesNotHaveDeadline: {
    code: 'stage/does-not-have-deadline',
    explanation:
      'A etapa não possui um prazo definido. Prazos são configurados por etapa no fluxo.',
    localizations: {},
    message: 'Esta etapa não possui um prazo definido.',
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  StageNotFound: {
    code: 'stage/not-found',
    explanation:
      'A etapa que você está tentando acessar não foi encontrada. Ela pode ter sido removida ou não existir neste fluxo.',
    localizations: {},
    message: 'A etapa solicitada não foi encontrada.',
  },
  StageStageCannotBeMovedLeft: {
    code: 'stage/stage-cannot-be-moved-left',
    explanation:
      'A etapa não pode ser movida para a esquerda. Essa etapa já está na posição mais à esquerda.',
    localizations: {},
    message: 'Esta etapa não pode ser movida para a esquerda.',
  },
  StageStageCannotBeMovedRight: {
    code: 'stage/stage-cannot-be-moved-right',
    explanation:
      'A etapa não pode ser movida para a direita. Essa etapa já está na posição mais à direita.',
    localizations: {},
    message: 'Esta etapa não pode ser movida para a direita.',
  },
  StageUndeleteFailed: {
    code: 'stage/undelete-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar restaurar a etapa. Verifique suas informações e tente novamente.',
    localizations: {},
    message: 'Erro ao restaurar a etapa.',
  },
  StageUpdateFailed: {
    code: 'stage/update-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar atualizar a etapa. Verifique suas informações e tente novamente.',
    localizations: {},
    message: 'Erro ao atualizar a etapa. Verifique suas informações e tente novamente.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage'>;
